import { toast } from "react-toastify";
const optionsInjector = {
  apply: function (target, thisArg, argumentsList) {
    return target(argumentsList[0], { autoClose: 3000 });
  },
};

const toaster = {
  success: new Proxy(toast.success, optionsInjector),
  warning: new Proxy(toast.warning, optionsInjector),
  error: new Proxy(toast.error, optionsInjector),
};

export default toaster;
